export default "__VITE_ASSET__tP5ZmTqB__"